import { render, staticRenderFns } from "./DlgCeoDelete.vue?vue&type=template&id=bc23c4ec&scoped=true"
import script from "./DlgCeoDelete.vue?vue&type=script&lang=ts"
export * from "./DlgCeoDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc23c4ec",
  null
  
)

export default component.exports